<template>
  <ScreenForm action="create" />
</template>

<script>
import ScreenForm from '@/components/Screen/ScreenForm'

export default {
  components: {
    ScreenForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/screen/Create.vue